import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { hotRankings } from "@/mocks/hotNews";
import RankingRow from "@/components/feature/RankingRow";

const hotChips = ["娱乐圈", "影视综艺", "社会热点", "科技数码", "生活潮流"];

export default function HomeHero() {
  const [kw, setKw] = useState("");
  const navigate = useNavigate();
  const onSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(kw.trim() ? `/news?q=${encodeURIComponent(kw.trim())}` : "/news");
  };
  const top5 = hotRankings.slice(0, 5);

  return (
    <section className="container-x pt-4 md:pt-6">
      <div className="relative overflow-hidden rounded-3xl">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20abstract%20gradient%20background%20with%20flowing%20coral%20amber%20and%20cream%20ribbons%2C%20soft%20glowing%20bokeh%20particles%2C%20smooth%20silk%20waves%2C%20minimal%20artistic%20editorial%20style%2C%20high%20detail&width=1600&height=760&seq=home-hero-bg-01&orientation=landscape"
          alt="在线吃瓜 今日热瓜实时榜单背景图"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-background-950/75 via-primary-950/40 to-primary-800/20"></div>

        <div className="relative grid grid-cols-1 gap-8 px-5 py-12 md:grid-cols-12 md:px-10 md:py-16 lg:py-20">
          <div className="md:col-span-7 flex flex-col justify-center">
            <span className="chip w-fit bg-accent-500/95 px-3 py-1 text-xs font-bold text-primary-950">
              <i className="ri-flashlight-line"></i> 今日热瓜 · 实时更新中
            </span>
            <h1 className="mt-4 max-w-2xl font-heading text-3xl leading-tight text-background-50 md:text-5xl">
              今天，全网都在吃什么瓜？
            </h1>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
              实时榜单帮你快速锁定此刻最受关注的焦点，热门话题与新鲜事即时更新。追踪全网最新进展，不错过任何一条劲爆消息，吃瓜也要吃得清醒又尽兴。
            </p>

            <form onSubmit={onSearch} className="mt-6 flex max-w-lg items-center gap-1 rounded-full bg-background-50/95 p-1.5 shadow-soft">
              <i className="ri-search-line pl-3 text-foreground-500"></i>
              <input
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                placeholder="搜搜大家现在在聊什么"
                className="flex-1 bg-transparent text-sm outline-none placeholder:text-foreground-400"
              />
              <button type="submit" className="chip bg-primary-500 px-4 py-2 text-sm font-bold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer">
                去搜瓜
              </button>
            </form>

            <div className="mt-4 flex flex-wrap items-center gap-2">
              <span className="text-xs text-background-100/80">热门：</span>
              {hotChips.map((c) => (
                <button
                  key={c}
                  onClick={() => navigate(`/news?q=${encodeURIComponent(c)}`)}
                  className="chip bg-background-50/20 px-3 py-1 text-xs text-background-50 backdrop-blur transition-colors hover:bg-background-50/35 cursor-pointer"
                >
                  #{c}
                </button>
              ))}
            </div>
          </div>

          <div className="md:col-span-5">
            <div className="rounded-2xl bg-background-50/95 p-4 shadow-soft backdrop-blur md:p-5">
              <div className="mb-2 flex items-center justify-between">
                <h2 className="font-heading text-lg text-primary-700">
                  <i className="ri-fire-fill mr-1"></i>此刻热榜 TOP 5
                </h2>
                <button onClick={() => navigate("/ranking")} className="text-xs font-medium text-foreground-500 hover:text-primary-600 cursor-pointer">
                  完整榜单 <i className="ri-arrow-right-line"></i>
                </button>
              </div>
              <div className="divide-y divide-background-200/70">
                {top5.map((r) => (
                  <RankingRow key={r.item.slug} item={r.item} rank={r.rank} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}